import { useEffect, useRef } from "react";

// USED WHEN YOU NEED TO SKIP THE CALL ON FIRST RENDER
const useUpdateEffect = (callback, dependencies) => {
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }
    return callback();
    // eslint-disable-next-line
  }, dependencies);
};

export default useUpdateEffect;
